import React, { ReactNode } from 'react'
import styled from 'styled-components'
import CreationToolGradient from '../types/gradient'

const Banner = styled.div<{ colors: string[] }>`
    background: ${({ colors }) => `linear-gradient(45deg, ${colors[0]} 0%, ${colors[1]} 100%)`};
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
    color: #fff;
    font-size: 15px;
    font-weight: normal;
    height: 50px;
    line-height: 50px;
    text-align: center;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;

    i {
        display: inline-block;
        font-size: 14px;
        vertical-align: middle;
    }
    i:first-child {
        margin-right: 6px;
    }
    i:last-child {
        margin-left: 6px;
    }
`

type Props = {
    children?: ReactNode
    gradient?: CreationToolGradient
}

const CreationToolsModalBanner = ({ children, gradient = CreationToolGradient.PurpleRed }: Props) => (
    <Banner colors={CreationToolGradient.colors(gradient)}>{children}</Banner>
)

export default CreationToolsModalBanner
